import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { IndexType } from '@fnModels/algolia/algolia';
import { getIndex } from '@state/utils/helper';
import { AlgoliaSearchOptions } from '@state/utils/models';
import { AlgoliaBaseState, AlgoliaSearchState } from '..';
import * as actions from './financial-institution-search.actions';

export type FinancialInstitutionSearchStateModel = AlgoliaBaseState<unknown>;

@State<FinancialInstitutionSearchStateModel>({
	name: 'financialInstitutionSearch',
	defaults: {
		searchTerm: '',
		searching: false,
		success: null,
		error: null,
		items: [],
	},
})
@Injectable()
export class FinancialInstitutionSearchState extends AlgoliaSearchState<FinancialInstitutionSearchStateModel> {
	protected indexName = getIndex(IndexType.FINANCIAL_INSTITUTIONS);

	@Selector([FinancialInstitutionSearchState])
	static getList(state: FinancialInstitutionSearchStateModel) {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		const items = state?.items as unknown as any;

		return items.map((item) => ({
			...item,
			name: item.displayName || item.name,
		}));
	}

	@Action(actions.Reset)
	async reset(
		{ patchState }: StateContext<FinancialInstitutionSearchStateModel>,
		{}: actions.Reset,
	) {
		patchState({ searching: false, error: null, items: [] });
	}

	@Action(actions.Search)
	async search(
		ctx: StateContext<FinancialInstitutionSearchStateModel>,
		{ payload }: actions.Search,
	) {
		const requestOptions: AlgoliaSearchOptions = {};

		const facetFilters = [
			Object.keys(payload.filters)
				.filter((key) => payload.filters[key] === true)
				.reduce((prev, curr) => {
					prev.push(`type:${curr}`);
					return prev;
				}, []),
		];
		if (facetFilters?.length > 0) {
			requestOptions.facetFilters = facetFilters;
		}

		await this.algoliaSearchHandler(
			ctx,
			payload.searchValue,
			requestOptions,
			'items',
			(items) =>
				payload.filterCS
					? items?.filter((x) => x.objectID !== 'qnMR3Wv')
					: items,
		);
	}
}
